import { render, staticRenderFns } from "./Proveedores.vue?vue&type=template&id=77d737ff&"
import script from "./Proveedores.vue?vue&type=script&lang=ts&"
export * from "./Proveedores.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('77d737ff', component.options)
    } else {
      api.reload('77d737ff', component.options)
    }
    module.hot.accept("./Proveedores.vue?vue&type=template&id=77d737ff&", function () {
      api.rerender('77d737ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Proveedor/Proveedores.vue"
export default component.exports